import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { getArticleBySlug } from "../../../services/articleService";

import ArticleBreadcrumb from "./ArticleBreadcrumb";
import ArticleHeader from "./ArticleHeader";
import ArticleContent from "./ArticleContent";
import RelatedProducts from "./RelatedProducts";
import RelatedArticles from "./RelatedArticles";

import "./ArticleDetail.css";

export default function ArticleDetail() {
    const { slug } = useParams();

    const [article, setArticle] = useState(null);

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;

        async function loadArticle() {
            try {
                setLoading(true);
                setError(null);

                const response = await getArticleBySlug(slug);

                if (cancelled) {
                    return;
                }

                setArticle(response.data);

            } catch (error) {
                if (cancelled) {
                    return;
                }

                console.error(
                    "Failed to load article:",
                    error
                );

                setError(
                    error?.response?.data?.message ||
                    "مقاله مورد نظر پیدا نشد."
                );

            } finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        }

        if (slug) {
            loadArticle();
        }

        return () => {
            cancelled = true;
        };
    }, [slug]);

 console.log('categories',article);

    if (loading) {
        return (
            <div className="article-detail-page">
                <ArticleDetailSkeleton />
            </div>
        );
    }


    if (error || !article) {
        return (
            <div className="article-detail-page">
                <div className="article-detail__error">
                    {error || "مقاله پیدا نشد."}
                </div>
            </div>
        );
    }


    return (
        <main
            className="article-detail-page"
            dir="rtl"
        >

            <div className="container">

                <ArticleBreadcrumb
                    article={article}
                />

                <ArticleHeader
                    article={article}
                />

                <ArticleContent
                    article={article}
                />

                {article.relatedProducts?.length > 0 && (
                    <RelatedProducts
                        products={
                            article.relatedProducts
                        }
                    />
                )}

                {article.relatedArticles?.length > 0 && (
                    <RelatedArticles
                        articles={
                            article.relatedArticles
                        }
                    />
                )}

            </div>

        </main>
    );
}


/*
|--------------------------------------------------------------------------
| Loading Skeleton
|--------------------------------------------------------------------------
*/

function ArticleDetailSkeleton() {
    return (
        <div
            className="article-detail__skeleton container"
            dir="rtl"
        >

            <div className="skeleton skeleton-breadcrumb" />

            <div className="skeleton skeleton-title" />

            <div className="skeleton skeleton-meta" />

            <div className="skeleton skeleton-image" />

            <div className="skeleton skeleton-line" />
            <div className="skeleton skeleton-line" />
            <div className="skeleton skeleton-line" />
            <div className="skeleton skeleton-line short" />

        </div>
    );
}